module.exports = __webpack_public_path__ + "static/img/terminal_commands.2f2d5de.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/cpp/images/terminal_commands.png
// module id = HmNq
// module chunks = 1